/**
 * Generate the bookmarklet code for saving pages to Pith
 * Extracts HTML content client-side (bypasses robot blocking)
 * Server converts HTML to Markdown using Readability + Turndown
 */
export function getBookmarkletCode(): string {
  const baseUrl = window.location.origin;

  // Selectors for elements to remove (split for readability, joined in minified output)
  const removeSelectors = [
    // Scripts and styles
    'script',
    'style',
    'noscript',
    // Layout elements
    'nav',
    'header',
    'footer',
    'aside',
    'form',
    'iframe',
    // ARIA roles
    '[role="navigation"]',
    '[role="banner"]',
    '[role="contentinfo"]',
    '[role="complementary"]',
    '[aria-hidden="true"]',
    // Ads
    '.ad',
    '.ads',
    '.advertisement',
    '.advert',
    '[data-ad]',
    '[data-ads]',
    // Navigation
    '.sidebar',
    '.menu',
    '.nav',
    '.footer',
    '.header',
    '.breadcrumb',
    '.breadcrumbs',
    // Social/sharing
    '.social',
    '.share',
    '.sharing',
    '.follow',
    // Comments
    '.comment',
    '.comments',
    '.disqus',
    // Related content
    '.related',
    '.recommended',
    '.suggested',
    // Newsletter/subscription
    '.newsletter',
    '.subscribe',
    '.subscription',
    '.signup',
    '.sign-up',
    '.mailing-list',
    // Popups/modals
    '.popup',
    '.modal',
    '.overlay',
    '.lightbox',
    // Cookie/privacy
    '.cookie',
    '.cookie-banner',
    '.cookie-notice',
    '.gdpr',
    '.consent',
    // Promotions
    '.promo',
    '.promotion',
    '.sponsor',
    '.sponsored',
    // Tracking
    '[data-tracking]',
    '[data-analytics]',
    '[data-promo]',
  ].join(',');

  return `javascript:(function(){var g=function(e){var t=e.cloneNode(true);t.querySelectorAll('${removeSelectors}').forEach(function(n){n.remove()});return t.innerHTML};var f=function(){var a=document.querySelector('article')||document.querySelector('main')||document.querySelector('[role="main"]');if(a)return g(a);var b=document.body,m=0,r=b;b.querySelectorAll('div,section').forEach(function(e){if(e.offsetHeight>100){var t=e.cloneNode(true);t.querySelectorAll('script,style,nav').forEach(function(n){n.remove()});var l=t.innerText.length;if(l>m&&l<100000){m=l;r=e}}});return m>500?g(r):g(b)};var h=f(),t=document.title,u=location.href,p='${baseUrl}/save?mode=html&url='+encodeURIComponent(u)+'&title='+encodeURIComponent(t),o=window.open(p,'readlater','width=420,height=400,scrollbars=no,resizable=no');if(o){var s=function(){try{o.postMessage({type:'readlater-content',content:h,contentFormat:'html',title:t,url:u},'${baseUrl}')}catch(e){}};setTimeout(s,500);setTimeout(s,1500);setTimeout(s,3000)}})();`;
}
